var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvalanche(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-623 -116)",
    fill: "#0F1113"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -5,
    width: 98,
    height: 25,
    rx: 6,
    fill: "#22282C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -9.5,
    y: -4.5,
    width: 97,
    height: 24,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_1",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-623 -116)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_0_1",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABJ2lDQ1BrQ0dDb2xvclNwYWNlQWRvYmVSR0IxOTk4AAAokWNgYFJILCjIYRJgYMjNKykKcndSiIiMUmB/zsDOIMLAxcDGwJGYXFzgGBDgwwAEMBoVfLvGwAiiL+uCzMKUxwu4UlKLk4H0HyDOTi4oKmFgYMwAspXLSwpA7B4gWyQpG8xeAGIXAR0IZG8BsdMh7BNgNRD2HbCakCBnIPsDkM2XBGYzgeziS4ewBUBsqL0gIOiYkp+UqgDyvYahpaWFJol+IAhKUitKQLRzfkFlUWZ6RomCIzCkUhU885L1dBSMDIyMGRhA4Q5R/TkQHJ6MYmcQYgiAEJsjwcDgv5SBgeUPQsykl4FhgQ4DA/9UhJiaIQODgD4Dw745yaVFZVBjGJmAdhLiAwDRr0ovDPSa5AAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAQKADAAQAAAABAAAAQAAAAABlmWCKAAADiElEQVR4Ae2bO28TQRDHdw8RJB4SQig4qfMBaKA+HxUFSEhp0lFATbqEb2BaOiigyQeggjTYLqCFD5CePJCgRki33Bjtab25fc+c7+ycFO16HzPz/83sOfE5nLV0neXFXsnZyMddJtj++nT8ymdt6hqeasC0/2RYCNNczPhgMiaJFd0otnAdFjYIFACnefFecPZUD5b0tWAfBtPxk1QfyQCoM+4SmFoR0QAWLVwHEwsiCkDXxEsYMRCCAHRVuAQg2xAQ3gD6Ij4UgheAvokPgeAE0FfxvhCsAPou3gdCJhctor0z/szgZ5GXsQKos68LPy0ekHIwvTM0VgC1eFKlBuMmTY0ADDbQhvXsg+GmMTSHFkPnAJhIWWygTVFDaNI2B+BkOPyOpsZgiFqkwW09fJznH+sXVWcOAGP8rjqJ3fcR77MmJS7Os4fqfg2AOrUa/fptsOl8YCIIzWxbb4sXFQBZ7lr2ZeW1UQUrXwHkAELPvsz+z+1t2SVtSQHcevsmOvjy1+/ovSEbsx95sRuyIWTt5a2tkOX12r9HR3WfsnNcPa3iVDfA2NIHwdQ3PxUq6RFQHfn22xQPMZEASMm+LyisdSQAYoNrO/sQJzoAquzfHI3Y+uGnWLbGfagArj9/ZnTkmrBl/9rODrty/x7ja2voH5ygAoBAKa4UsK540ACklL4t+012m8ZcQk3zaABMDlzjNvGuvRjzKAAwM6KKstm1zak2XP2sFOylaxHVfGr2bx8cJIYmXmSb07HXN7dMnrAyodv3sXtpc0PfFvR6MJm8TjoCN3bj/46yZd9HvFQaslbuUdskAFcfP1Jt9bIfDSCFPFb2JfGUWGYATA8OpQPM1iYe04/LltQcXQEuB23Px1ZBDUAS8Q38z5evvktn6yDzlNkPsa1qrR+MQJRUnw4FkWphsQqgrgDwy4U4bMH/Ql2Ikn1TA5irAJhY9ipQsw96zwFYZgi6eNA6dwRgYNWuxgoACMt2FJqyDzqNAJYJgkk8aLw4AkDBdvX9KNiyD7qtR0CC6SsEl3hvALCwbxB8xAcB6BMEX/HBAGADXF2thhDh/5V43gPkYrXtGoQY8aDH6yaoCtf7iwYRK1zqSP49YBZA9U+M0mBrbcnfpYqHWJMrQBdMXREYotWY0QFI4xWIEhGwqIQnV6uMTW3JAKhOoF99S3uv+qKy10MYIcr9jem0lX+f/wfQOA0opvMnaAAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.741f85a415141b78d39fc257447070ba.svg";
export { ForwardRef as ReactComponent };